import { render, staticRenderFns } from "./Text.template.vue?vue&type=template&id=54649f89&scoped=true&"
var script = {}
import style0 from "./Text.template.vue?vue&type=style&index=0&id=54649f89&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54649f89",
  null
  
)

export default component.exports